import {Period} from '../../common/model/period.model';
import {TipoGerarchia} from '../../+configurazione/tipogerarchia/tipogerarchia.model';
import {EntitaOrganizzativa} from '../entitaorganizzativa/entitaorganizzativa.model';
import {TableRow} from '../../common/model/table-row.model';
import {TableRowValue} from '../../common/model/table-row-value.model';
import {Helpers} from '../../common/helpers/helpers';
import {Select2Template} from '../../common/template/select2-template';

export class Gerarchia extends Period {

  constructor(protected id: number,
                public figlioGuida: boolean,
                public padre: EntitaOrganizzativa,
                public figlio: EntitaOrganizzativa,
                public tipo: TipoGerarchia,
                public inizioValidita: string,
                public fineValidita: string
  ) {
    super(id, inizioValidita, fineValidita);
  }

  public static getTableKeys() {
    return ['id', 'tipo', 'padre', 'figlio', 'inizioValidita', 'fineValidita', 'guida'];
  }

  public toTableRow(): TableRow {
    const rowValues = new Map();
    rowValues.set('id', new TableRowValue(this.id, null));
    rowValues.set('tipo', new TableRowValue(this.tipo.getLabel(), null));
    if (this.padre) {
      rowValues.set('padre', new TableRowValue(this.padre, Select2Template.entitaOrganizzativaSiglaCityRow));
    } else {
      rowValues.set('padre', new TableRowValue(null, null));
    }
    rowValues.set('figlio', new TableRowValue(this.figlio, Select2Template.entitaOrganizzativaSiglaCityRow));
    rowValues.set('inizioValidita', new TableRowValue(Helpers.formatDateView(this.getInizio()), null));
    rowValues.set('fineValidita', new TableRowValue(Helpers.formatDateView(this.getFine()), null));
    rowValues.set('guida', new TableRowValue(this.figlioGuida, null));
    return new TableRow(this, rowValues);
  }

  public getLabel() {
    return 'Gerarchia ' + this.id;
  }

}

